// https://stackoverflow.com/questions/18883601/function-to-calculate-distance-between-two-coordinates
export const distInKm = (lat1, lon1, lat2, lon2) => {
  if (lat1 === lat2 && lon1 === lon2) return 0
  var radlat1 = (Math.PI * lat1) / 180
  var radlat2 = (Math.PI * lat2) / 180
  var theta = lon1 - lon2
  var radtheta = (Math.PI * theta) / 180
  var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta)
  dist = Math.acos(dist)
  dist = (dist * 180) / Math.PI
  return dist * 60 * 1.853159616
}

export class ResumableTimer {
  constructor(callback, delay) {
    this.remaining = delay
    this.callback = callback.bind(null)
    this.delay = delay
    this.resume()
  }

  pause() {
    if (this.id) clearTimeout(this.id)
    this.remaining -= Date.now() - this.start
  }
  resume() {
    if (this.id) clearTimeout(this.id)
    this.start = Date.now()
    this.id = setTimeout(() => {
      this.callback()
      this.restart()
    }, this.remaining)
  }
  restart() {
    this.remaining = this.delay
    this.resume()
  }
}
